export default function Services() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Kitchen Remodeling',
      description: 'Transform your kitchen into a modern culinary space with custom cabinets and premium finishes.',
      price: 'From $15,000',
    },
    {
      icon: 'ri-drop-line',
      title: 'Bathroom Renovation',
      description: 'Create your perfect spa-like retreat with elegant fixtures and contemporary design.',
      price: 'From $8,000',
    },
    {
      icon: 'ri-pencil-ruler-2-line',
      title: 'Professional Design Services Available',
      description: 'Expert interior design by Dorothie Miller, a proud member of the National Kitchen and Bath Association (NKBA) with 30 years of experience bringing your vision to life.',
      price: '',
    },
    {
      icon: 'ri-building-line',
      title: 'Home Remodeling and Repairs',
      description: 'Full-scale home transformations including basements, rec rooms, bars, laundry rooms, etc.',
      price: 'From $50,000',
    },
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-start justify-between mb-12">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              OUR SERVICES <span className="text-blue-600">EXPERTISE</span>
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl">
              Comprehensive remodeling solutions tailored to your vision and budget
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer group"
            >
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}